<template>
    <a-popover
        v-model="visible"
        trigger="click"
        title="异常订单">
        <template slot="content">
            <a-radio-group
                :options="exceptionOptions"
                @change="onChangeException"
                v-model="currentException" />
            <div
                v-on:click="confirm"
                class="exception-confirm-button">
                确认订单
            </div>
        </template>
        <a-button
            class="button">
            异常订单
        </a-button>
    </a-popover>
</template>

<script>
 import Vue from 'vue';
 import Button from "ant-design-vue/lib/button";
 import EventBus from "../event/event-bus.js"

 import { fetchExceptionOptions } from "../util/order.js"
 import { mapGetters } from 'vuex'
 import { confirmException } from "../util/order.js"
 import { notifyWarning } from "../util/notify.js"

 Vue.component(Button.name, Button);

 export default {
     name: 'ExceptionButton',
     data() {
         return {
             visible: false
         }
     },
     props: {
     },
     computed: {
         ...mapGetters([
             "exceptionOptions"
         ]),
         currentException: {
             get() { return this.$store.getters.currentException },
             set(value) { this.$store.commit('updateExceptionOption', value ) }
         },
     },
     components: {
     },
     created() {
         console.log("Create ExceptionButton")
     },
     mounted() {
         console.log("Mount ExceptionButton")

         var that = this
         fetchExceptionOptions(
             function(response) {
                 var options = []

                 for (var i = 0; i < response.length; i++) {
                     options.push({
                         label: response[i].AbnormalDesc,
                         value: response[i].AbnormalTypeId,
                     })
                 }

                 that.$store.commit("updateExceptionOptions", options)
             }
         )
     },
     methods: {
         onChangeException(e) {
             this.$store.commit("updateExceptionOption", e.target.value)
         },
         confirm() {
             if (this.$store.getters.currentException == -1) {
                 notifyWarning(
                     "异常订单",
                     "请先选择一个异常订单的类型"
                 )
             } else {
                 this.visible = false
                 confirmException(
                     this.$store.getters.orderId,
                     this.$store.getters.currentException,
                     function() {
                         EventBus.$emit("fetchNextOrder")
                     }
                 )
             }
         }
     }
 }
</script>

<style scoped>
 .button {
     background: #D80E3B;
     color: #FFF;
     border: none;
     margin-right: 10px;
     height: 50px;
     width: 40%;
 }

 .ant-radio-group-default {
     display: flex;
     flex-direction: column;
 }

 .exception-confirm-button {
     width: 140px;
     color: #FFFFFF;
     font-size: 16px;
     background-color: #D80E3B;
     border-radius: 5px;
     padding-left: 10px;
     padding-right: 10px;
     padding-top: 4px;
     padding-bottom: 4px;
     margin-top: 20px;
     margin-left: 5px;
     margin-right: 10px;
     text-align: center;
     user-select: none;
 }
</style>
